import { render, staticRenderFns } from "./BibliaRegistrosPage.vue?vue&type=template&id=621d603c"
import script from "./BibliaRegistrosPage.vue?vue&type=script&lang=js"
export * from "./BibliaRegistrosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports